var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "myCenter"
  }, [_c('Header'), _c('div', {
    staticClass: "usercont content"
  }, [_c('div', {
    staticClass: "left navmenu"
  }, _vm._l(_vm.menus, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "top"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "m_icon",
      on: {
        "click": function click($event) {
          item.isOpen = !item.isOpen;
        }
      }
    }, [_c('i', {
      class: item.isOpen ? 'el-icon-minus' : 'el-icon-plus'
    })]), _c('ul', _vm._l(item.child, function (child, key) {
      return _c('li', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: item.isOpen,
          expression: "item.isOpen"
        }],
        key: child.id,
        class: {
          'active': _vm.currentIndex === key
        },
        on: {
          "click": function click($event) {
            return _vm.goList(key);
          }
        }
      }, [_vm._v(_vm._s(child.title))]);
    }), 0)]);
  }), 0), _c('div', {
    staticClass: "menucont"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "orderlist"
  }, [_c('span', [_vm._v("材质：")]), _c('em', [_vm._v(_vm._s(_vm.infor.materialName))])]), _c('div', {
    staticClass: "orderlist"
  }, [_c('span', [_vm._v("尺寸：")]), _c('em', [_vm._v(_vm._s(_vm.infor.size))])]), _c('div', {
    staticClass: "orderlist"
  }, [_c('span', [_vm._v("张数：")]), _c('em', [_vm._v(_vm._s(_vm._f("formatNum")(String(_vm.infor.orderNum))) + "张")])]), _c('div', {
    staticClass: "orderlist"
  }, [_c('span', [_vm._v("类型：")]), _c('em', [_vm._v(_vm._s(_vm.infor.colorItem))])]), _c('div', {
    staticClass: "orderlist"
  }, [_c('span', [_vm._v("联系方式：")]), _c('em', [_vm._v(_vm._s(_vm.infor.phone))])]), _vm.infor.detail && _vm.infor.detail.length !== 0 ? _c('div', {
    staticClass: "orderlist ordercont"
  }, [_c('span', [_vm._v("打印内容：")]), _c('div', [_c('viewer', {
    attrs: {
      "images": _vm.infor.detail
    }
  }, _vm._l(_vm.infor.detail, function (item, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": item.sourceUrl
      }
    });
  }), 0)], 1)]) : _vm._e(), _vm.currentIndex === 1 && _vm.infor.colorStr ? _c('div', {
    staticClass: "orderlist"
  }, [_c('span', {
    staticClass: "comments"
  }, [_vm._v("颜色数量：")]), _c('em', [_vm._v(_vm._s(_vm.infor.colorStr))])]) : _vm._e(), _vm.infor.mallExcel ? _c('div', {
    staticClass: "orderlist"
  }, [_c('span', [_vm._v("Excel文件：")]), _c('a', {
    attrs: {
      "href": _vm.infor.mallExcel.sourceUrl
    }
  }, [_vm._v(_vm._s(_vm.infor.mallExcel.sourceName) + ".xlsx")])]) : _vm._e(), _c('div', {
    staticClass: "orderlist"
  }, [_c('span', {
    staticClass: "comments"
  }, [_vm._v("备注：")]), _c('em', [_vm._v(_vm._s(_vm.infor.orderRemark))])])])])]), _c('BackTop', {
    attrs: {
      "hasShopping": false
    }
  }), _c('Footer')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };